import { useContext, useEffect } from 'react';

import type { HeadProps, PageProps } from 'gatsby';

import { Seo } from 'components/seo';
import { AppStateContext } from 'context/AppContextProvider';
import { App } from 'layout';
import { HomeScreen } from 'screens';
import { homeSchema } from 'schemas/home-schema';

const IndexPage = ({ location }: PageProps) => {
    const userState = useContext(AppStateContext);

    useEffect(() => {
        if (userState?.loaded && userState?.authenticated && userState?.canRedirect) {
            navigateToElumityApp();
        }
    }, [userState]);

    const navigateToElumityApp = () => {
        if (process.env.GATSBY_ELUMITY_APP_URL) {
            window.location.href = process.env.GATSBY_ELUMITY_APP_URL;
        }
    };

    return (
        <>
            {userState?.loaded && (!userState?.authenticated || !userState?.canRedirect) ? (
                <App isLandingPage={true} location={location}>
                    <HomeScreen />
                </App>
            ) : null}
        </>
    );
};

export default IndexPage;

export const Head = ({ location }: HeadProps) => (
    <Seo
        title="Elumity | Your Academic Knowledge Management Home"
        description="Elumity is a personal software suite designed to help academics collect, build, and share knowledge efficiently."
        pathname={location.pathname}>
        {process.env.GATSBY_SITE_URL === 'https://elumity.com' ? (
            <>
                <script src="https://cdn.amplitude.com/libs/analytics-browser-2.11.1-min.js.gz"></script>
                <script src="https://cdn.amplitude.com/libs/plugin-session-replay-browser-1.8.0-min.js.gz"></script>
                <script>
                    {`
            <!-- Hotjar Tracking Code -->
            (function(h,o,t,j,a,r){
            h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
            h._hjSettings={hjid:3878544,hjsv:6};
            a=o.getElementsByTagName('head')[0];
            r=o.createElement('script');r.async=1;
            r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
            a.appendChild(r);
            })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
            <!-- End Hotjar Tracking Code -->

            <!-- Google Tag Manager -->
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-KFLMDN5Z');
            <!-- End Google Tag Manager -->

            <!-- Amplitude Analytics -->
                window.amplitude.add(window.sessionReplay.plugin({sampleRate: 1}));
                window.amplitude.init('ccf9d804aec73b74b7c33c527049c3c4', {"autocapture":{"elementInteractions":true}});
            <!-- End Amplitude Analytics -->
            `}
                </script>
                <script type="application/ld+json">{JSON.stringify(homeSchema)}</script>
            </>
        ) : (
            ''
        )}
    </Seo>
);
